import _globalThis2 from "../internals/global-this";
import _fails from "../internals/fails";
import _checkCorrectnessOfIteration from "../internals/check-correctness-of-iteration";
import _arrayBufferViewCore from "../internals/array-buffer-view-core";
var exports = {};
/* eslint-disable no-new, sonarjs/inconsistent-function-call -- required for testing */
var _globalThis = _globalThis2;
var fails = _fails;
var checkCorrectnessOfIteration = _checkCorrectnessOfIteration;
var NATIVE_ARRAY_BUFFER_VIEWS = _arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var ArrayBuffer = _globalThis.ArrayBuffer;
var Int8Array = _globalThis.Int8Array;
exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array(1);
}) || !fails(function () {
  new Int8Array(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array();
  new Int8Array(null);
  new Int8Array(1.5);
  new Int8Array(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
});
export default exports;